export const AssetStatus = {
  NONE: 'none',
  READY: 'ready',
  UPLOADING: 'uploading',
  UPLOADED: 'uploaded',
  PROCESSING: 'processing',
  FAILED: 'failed',
  CONVERTING: 'converting',
} as const;

export type AssetStatusValue = (typeof AssetStatus)[keyof typeof AssetStatus];
